// extracted by mini-css-extract-plugin
export var content = "DialogLayout-module--content--c409a";
export var header = "DialogLayout-module--header--3ef84";
export var headerCenter = "DialogLayout-module--headerCenter--4b67f";
export var headerLeft = "DialogLayout-module--headerLeft--b3ead";
export var headerRight = "DialogLayout-module--headerRight--38114";
export var layout = "DialogLayout-module--layout--a310d";